import{gql as t}from"@apollo/client";const n=t`
  mutation updateSettings($settings: [SettingInput]!) {
    settings {
      add(settings: $settings)
    }
  }
`;export{n as UPDATE_SETTINGS};
//# sourceMappingURL=useUpdateSettings.graphql.js.map
